import React, { useState } from "react";

export default function RunDisabledProcessButton({token, onSuccess}) {
  const [loading, setLoading] = useState(false);

  const handleRun = async () => {
    const ask = window.confirm(
      "Proses ini akan menjalankan disable/renew user.\nPastikan data sudah benar.\n\nLanjutkan?"
    );
    if (!ask) return;

    try {
      setLoading(true);

      const res = await fetch(
          `https://api.wifikamu.my.id/disable-user`,
          {
            headers: { authorization: token },
          }
        );
      const data = await res.json();

      alert(`✔ ${data.message}`);

      // Refresh parent
      onSuccess && onSuccess();

    } catch (err) {
      alert("❌ Proses gagal, coba lagi.\n\nError: " + err.message);

    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleRun}
      disabled={loading}
      className={`px-4 py-2 rounded text-white text-sm font-medium 
        ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-orange-600 hover:bg-orange-700"}`}
    >
      {loading ? "Processing..." : "Run Disabled Process"}
    </button>
  );
}
